import React, { Component } from 'react'
import moment from 'moment'

import ICalendarLink from "react-icalendar-link";
import AriaMessage from '../common/ariaMessage'
import Title from '../common/title'
import Logo from '../common/logo'
import './invite.css'

export default class InvitePage extends Component {
  constructor(props) {
    super(props)
    document.title = "Calendar Invite"
  }

  componentDidMount() {
    window.scrollTo(0, 0)
    document.getElementById("calendar_link").click();
  }

  displayCalendar(session) {
    var eventEnd = moment(session).add(20, 'minutes')
    const event = {
      title: "Live Newtopia Coaching Session",
      description: "If for any reason you need to change or cancel your scheduled session, please reach out to our Client Care team at 1 888 639 8181 or clientcare@newtopia.com. \\n\\nYours in good health,\\nThe Newtopia Team",
      startTime: session.format(),
      endTime: eventEnd.format(),
      location: "video chat or call"
    }
    return (
        <div className="ical-container">
          <ICalendarLink id= 'calendar_link' filename="Live Newtopia Coaching Session.ics" event={event}>
              <button
                id="controls_next_button"
                className="invite-button"
                aria-labelledby="controls_next_button"
                //aria-describedby={this.props.ariaDescribedby ? this.props.ariaDescribedby : ""}
              >
              Download
              </button>
          </ICalendarLink>
        </div>
    )
  }

  render() {
    const { startTime } = this.props 
    return (
      <div>
        <div className="container header">
          <Logo />
        </div>
        <AriaMessage message="Navigated to Calendar Invite page" />
        <Title>Calendar Invite</Title>
        <div className="container">
          <div className="invite-header">
            iCal file has been created. Close the window or click button Download to create the file again
          </div>
          <br/>
          {this.displayCalendar(startTime)}
        </div>
        <hr className="footer-separator" />
      </div>
    )
  }
}